<template>
  <div class="gift-box-index">
    <div class="top-banner">
      <div class="image-gradient-bottom"></div>
      <div class="top-banner-content">
        <p :class="isPhone ? 'merriweather-reg-32' : 'merriweather-reg-40'">Le coffret cadeau Hortense</p>
        <p class="merriweather-reg-18">Le 1er coffret cadeau pour une évasion éco-chic : un guide pour s’inspirer, une carte cadeau pour s’évader.</p>
      </div>
    </div>
    <div class="mt-5">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <p :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'" class=" mb-0">Le Coffret cadeau Hortense : </p>
        <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="mb-0">bien plus qu’une simple nuit</p>
        <p :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'" class="text-center mb-2">Un séjour personnalisé, enrichi de <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">découvertes</span> et de <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">privilèges</span></p>
      </div>
    </div>
    <div class="mb-5 coffert-hortense-container" :class="isPhone ? '' : 'mt-2'">
      <CoffretHortense />
      <div class="d-flex w-100 justify-content-center align-items-center mt-5" :class="isPhone ? 'px-5' : ''">
        <div class="hortense-btn-primary" @click="goToLink('/coffrets-cadeaux/paiement')">OFFRIR UNE EXPÉRIENCE UNIQUE</div>
      </div>
    </div>
    <div class="exceptional-places position-relative">
      <div class="d-flex flex-column align-items-center justify-content-center" :class="isPhone ? '' : 'padding-header'">
        <div :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-26'">Des lieux</div>
        <div :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'">d’exception</div>
        <p :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'" class="text-center">Découvrez plus <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">1 670 expériences au choix</span> : séjour gastronomique, pause bien-être, parenthèse insolite, escapade en pleine nature…</p>
      </div>
      <div class="exceptional-places-slider">
        <CardSlider
          v-if="collectonsData.length > 0"
          :items="collectonsData"
          :slidesToShow="isPhone ? 2 : 6"
          data-aos="fade-up" data-aos-duration="900"
        />
      </div>
      <div class="d-flex w-100 justify-content-center align-items-center" :class="isPhone ? 'px-5' : 'mt-5'">
        <div class="hortense-btn-primary" @click="goToLink('/coffrets-cadeaux/paiement')">OFFRIR UNE EXPÉRIENCE UNIQUE</div>
      </div>
    </div>
    <div class="exceptional-gift mt-5">
      <div class="d-flex flex-column align-items-center justify-content-center">
        <div class="merriweather-reg-26">Le choix d’un cadeau</div>
        <div :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'">d’exception</div>
        <p :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'" class="text-center">Ce qui rend nos coffrets cadeaux <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">uniques</span></p>
      </div>
      <ExceptionalGiftExperience />
      <div class="d-flex w-100 justify-content-center align-items-center mt-5" :class="isPhone ? 'px-5' : ''">
        <div class="hortense-btn-primary" @click="goToLink('/coffrets-cadeaux/paiement')">OFFRIR UN COFFRET</div>
      </div>
    </div>
    <div class="gift-box-info-container">
      <div class="row">
        <div class="col-12 col-md-7 d-flex flex-column align-items-center justify-content-center text-center gap-4 w-100" data-aos="fade-up" data-aos-duration="900">
          <h2 :class="isPhone ? 'merriweather-reg-20' : 'merriweather-reg-24'">Notre coffret</h2>
          <p :class="isPhone ? 'merriweather-reg-28' : 'merriweather-reg-40'" class="merriweather-reg-40">Cadeau Hortense</p>
          <p :class="isPhone ? 'merriweather-light-18' : 'merriweather-light-24'" class="pt-2">Le coffret cadeau Hortense vous ouvre les portes de <span :class="isPhone ? 'merriweather-light-italic-18' : 'merriweather-light-italic-24'">lieux uniques</span>, où chaque nuit conjugue élégance, authenticité et respect de l’environnement.</p>
          <p class="raleway-reg-p15">Offrez des séjours éco-chic dans des lieux d’exception, accompagnés d’une conciergerie sur mesure, de privilèges exclusifs, et d’une pochette éco-conçue. Chaque coffret comprend également un guide de voyage pour voyager autrement, afin de sensibiliser au tourisme responsable et faire vivre une expérience unique, porteuse de sens.</p>
          <div class="d-flex w-100 justify-content-center align-items-center" :class="isPhone ? 'px-5 mt-2' : 'mt-5'">
            <div class="hortense-btn-primary" @click="goToLink('/coffrets-cadeaux/paiement')">OFFRIR UN COFFRET</div>
          </div>
        </div>
        <div class="col-12 col-md-5" :class="isPhone ? 'mt-4' : ''" >
          <div class="zoom-img-container cadeau-hortense-img" @click="goToGroup('/programme-fidelite-club-hortense')" data-aos="fade-up" data-aos-duration="900">
            <img src="https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+BtoC/GIF-coffret-cadeau.gif" alt="Cadeau Hortense" class="img-fluid zoom-img" />
          </div>
        </div>
      </div>
    </div>
    <div class="collections-overview-container">
      <ExperienceCollections :user="user" />
    </div>
    <div class="footer-bottom-container my-5" data-aos="fade-up" data-aos-duration="900">
      <div class="footer-item">
        <div class="footer-img">
          <img src="../../images/HouseShape.svg" v-set-alt style="width: 50px;height: 43px;">
        </div>
        <p class="raleway-semi-p15 text-center mt-2">Des adresses éco-chic triées sur le volet</p>
      </div>
      <div class="footer-item">
        <div class="footer-img">
          <img src="../../images/calendar-footer.svg" v-set-alt style="width: 40px;height: 42px;">
        </div> 
        <p class="raleway-semi-p15 text-center mt-2">Disponibilité toute l’année</p>
      </div>
      <div class="footer-item">
        <div class="footer-img">
          <img src="../../images/checkBadge.svg" v-set-alt style="width: 35px;height: 50px;">
        </div> 
        <p class="raleway-semi-p15 text-center mt-2">Valable 2 ans</p>
      </div>
      <div class="footer-item">
        <div class="footer-img">
          <img src="../../images/busIcon.svg" v-set-alt style="width: 81px;height: 43px;">
        </div>
        <p class="raleway-semi-p15 text-center mt-2">Livraison physique</p>
      </div>
      <div class="footer-item">
        <div class="footer-img">
          <img src="../../images/circleWithCheck.svg" v-set-alt style="width: 52px;height: 48px;">
        </div>
        <p class="raleway-semi-p15 text-center mt-2">Disponibilité immédiate en e-coffret</p>
      </div>
      <div class="footer-item">
        <div class="footer-img">
          <img src="../../images/instantBooking.svg" v-set-alt style="width: 61px;height: 50px;">
        </div>
        <p class="raleway-semi-p15 text-center mt-2">Réservation instantanée de séjour en ligne</p>
      </div>
    </div>
    <GiftBoxLimitedFaqs selected-type="entreprise" />
  </div>
</template>
<script>
import fetcher from "packs/shared/api.js";
import CardSlider from "../../components/shared/CardSlider.vue";
import ExceptionalGiftExperience from "./ExceptionalGiftExperience.vue";
import ExperienceCollections from './ExperienceCollections.vue';
import CoffretHortense from './CoffretHortense.vue';
import GiftBoxLimitedFaqs from './GiftBoxLimitedFaqs.vue';
export default {
  name: "GiftBoxIndex",
  props: ['user'],
  components: {
    CardSlider,
    ExceptionalGiftExperience,
    ExperienceCollections,
    CoffretHortense,
    GiftBoxLimitedFaqs
  },
  data() {
    return {
      isPhone: window.innerWidth <= 768,
      collectonsData: []
    };
  },
  async mounted() {
    const navbarItems = document.querySelectorAll('.bm-burger-bars');
    const responseCollections = await fetcher.get("/collections/");
    this.collectonsData = responseCollections.data.map(collection => ({
      image: collection.photo_key || "https://hortense-vue.s3.eu-west-3.amazonaws.com/static/default.jpg",
      text_content: `<div class="d-flex flex-column"><p class="merriweather-italic-24 mb-1">${collection.name}</p><p class="raleway-bold-p16">${collection.title}</p></div>`,
      link: "/collections/" + collection.slug
    }));
    navbarItems.forEach((bar) => {
      bar.style.color = 'white';
      bar.style.backgroundColor = 'white';
      bar.style.border = '0.5px solid white';
    });
  },
  methods: {
    goToLink(link) {
      window.open(link, '_blank');
    }
  }
};
</script>
<style scoped lang="scss">
.gift-box-index {
  width: 100%;
  .top-banner {
    height: 399px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+couverture/page-couverture-BtoC-desktop.webp');
    background-size: cover;

    @media screen and (max-width: 767px) {
      background-image: url('https://conversions-api-gateway-9083319738648672-s3bucket-zfjcs6au7hlj.s3.eu-west-3.amazonaws.com/Coffrets+cadeaux+-+couverture/page-couverture-BtoC-mobile.webp');
      background-size: cover;
    }

    .top-banner-content {
      width: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      text-align: center;
      color: white;
    }

    .image-gradient-bottom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 115%;
      background: linear-gradient(to top, rgba(0, 0, 0, 0.6), transparent);
      pointer-events: none;
    }
  }
  .coffert-hortense-container {
    padding: 0 7% 0 7%;
  }

  .exceptional-places-slider {
    padding: 0 7% 0 7%;
  }

  .exceptional-gift {
    padding: 0;
  }

  .gift-box-info-container {
    min-height: 596px;
    gap: 138px;
    padding-top: 70px;

    .row {
      background: #A5D3AE48;
      padding: 34px 113px 33px 95px;

      @media screen and (max-width: 767px) {
        padding: 34px 22px 34px 22px;
      }
    }

    .cadeau-hortense-img {
      width: 100%;
      height: 524px;

      @media screen and (max-width: 767px) {
        height: 325px;
      }
    }

    .zoom-img {
      width: 100%;
      height: 100%;
      object-fit: cover;

      @media screen and (max-width: 767px) {
        width: 100%;
        height: 325px;
      }
    }

    .link-text{
      text-decoration: underline;
      color: black;
    }
  }

  .collections-overview-container {
    padding: 5% 1% 0 1%;
  }

  .footer-bottom-container {
    min-height: fit-content;
    background: #CFE5DC9D;
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    padding: 41px 80px 34px 84px;

    @media screen and (max-width: 767px) {
      grid-template-columns: repeat(2, 1fr);
      padding: 40px;
    }
    
    gap: 1rem;

    .footer-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;

      .footer-img {
        height: 50px;
      }
    }

    .footer-icon {
      width: auto;
      max-height: 50px;
      margin-bottom: 10px;
    }

    .footer-text {
      font-family: 'Raleway', sans-serif;
      font-weight: 600;
      font-size: 15px;
      line-height: 1.3;
    }
  }
  @media only screen and (max-width: 767px) {
    .top-banner {
      height: 503px;

      .top-banner-content {
        padding: 40px;
      }
    }

    .coffert-hortense-container {
      padding: 0px 3% 0px 3% !important;
    }

    .exceptional-gift, .exceptional-places-slider {
      padding: 0px 3% 0px 3% !important;
    }
  }

  .padding-header {
    padding: 0 8% 0 8%;
  }
}
</style>